import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./index.scss";
import registerImage from "../../assets/images/registerBg.png"; // Using the same image as login for now
import img from "../../assets/images/double-check.gif";
export const RegisterPage = () => {
  const [formData, setFormData] = useState({
    email: "",
    telephone: "",
    password: "",
    confirmPassword: "",
  });
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false); // 🔹 Nouveau state modal

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    setAcceptPolicy(e.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch("https://api.almasecret.msit-demo.fr/users", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.email.split("@")[0], // Use email prefix as name
          email: formData.email,
          password: formData.password,
          role: "client",
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // ✅ Ouvrir le modal au lieu d'alert
        setShowModal(true);
      } else {
        setError(data.message || "Erreur lors de l'inscription");
      }
    } catch (error) {
      setError("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid =
    formData.email.trim() !== "" &&
    formData.telephone.trim() !== "" &&
    formData.password.trim() !== "" &&
    formData.confirmPassword.trim() !== "" &&
    formData.password === formData.confirmPassword &&
    acceptPolicy;

  return (
    <div className="register-page">
      <div className="register-container">
        {/* Left side - Image section */}
        <div className="register-image-section">
          <div className="register-product-image">
            <img
              src={registerImage}
              alt="Two women with Alma Secret product"
              className="register-portrait-image"
            />
          </div>
        </div>

        {/* Right side - Registration form */}
        <div className="register-form-section">
          <div className="register-form-container">
            <div className="register-logo-section">
              <div className="register-brand-logo">Alma Secret.</div>
              <div className="register-brand-subtitle">
                NATURAL & THERMAL COSMETICS
              </div>
            </div>

            <h1 className="register-form-title">INSCRIVEZ-VOUS!</h1>

            <form onSubmit={handleSubmit} className="register-form">
              {/* Champs email */}
              <div className="register-form-group">
                <div className="register-input-wrapper">
                  <span className="register-input-icon">✉</span>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="EMAIL*"
                    required
                  />
                </div>
              </div>

              {/* Champs téléphone */}
              <div className="register-form-group">
                <div className="register-input-wrapper">
                  <span className="register-input-icon">☎</span>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleInputChange}
                    placeholder="TELEPHONE*"
                    required
                  />
                </div>
              </div>

              {/* Mot de passe */}
              <div className="register-form-group">
                <div className="register-input-wrapper">
                  <span className="register-input-icon">***</span>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="MOT DE PASSE*"
                    required
                  />
                </div>
              </div>

              {/* Confirmation mot de passe */}
              <div className="register-form-group">
                <div
                  className={`register-input-wrapper ${
                    formData.confirmPassword &&
                    formData.password !== formData.confirmPassword
                      ? "error"
                      : ""
                  }`}>
                  <span className="register-input-icon">***</span>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    placeholder="CONFIRMER LE MOT DE PASSE*"
                    required
                  />
                </div>
                {formData.confirmPassword &&
                  formData.password !== formData.confirmPassword && (
                    <div className="register-password-error">
                      Les mots de passe ne correspondent pas
                    </div>
                  )}
              </div>

              {/* Politique */}
              <div className="register-checkbox-group">
                <input
                  type="checkbox"
                  id="acceptPolicy"
                  checked={acceptPolicy}
                  onChange={handleCheckboxChange}
                  className="register-checkbox"
                />
                <label
                  htmlFor="acceptPolicy"
                  className="register-checkbox-label">
                  J'accepte la politique de confidentialité
                </label>
              </div>

              {error && <div className="register-error">{error}</div>}

              <button
                type="submit"
                className={`register-button ${
                  !isFormValid || isLoading ? "disabled" : ""
                }`}
                disabled={!isFormValid || isLoading}>
                <span className="register-play-icon">▶</span>
                {isLoading ? "INSCRIPTION EN COURS..." : "COMMENCEZ"}
              </button>

              <div className="register-login-link">
                <span>VOUS AVEZ DEJA UN COMPTE?</span>
                <a href="/login-page" className="register-login-text">
                  CONNECTEZ-VOUS
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ✅ Modal d'inscription réussie */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="custom-modal">
        <div className="d-flex align-items-center  justify-content-center flex-column p-5">
          {" "}
          <img src={img} />
          <h1 className="title-modal">
            compte créer <br />
            avec succés.
          </h1>
          <button
            className="btn-modal mt-5"
            onClick={() => (window.location.href = "/login-cart-page")}>
            poursuivre
          </button>
        </div>
      </Modal>
    </div>
  );
};
